// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".downgrade-desc {\n  line-height: 1.4rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n}\n.legal-text {\n  font-size: 0.875em;\n  color: var(--gray-600);\n}", ""]);
// Exports
module.exports = exports;
